export default [
  {
    path: window.pathApp + '/',
    name: 'parlamentares e governantes',
    component: () => import('@/components/Parlamentares'),
    meta: {
      login: false,
      title: "Parlamentares  e governantes",
    }
  },
  {
    path: window.pathApp + '/direcoes-e-diretorios',
    name: 'Direções e diretórios',
    component: () => import('@/components/Direcoes'),
    meta: {
      login: false,
      title: "Direções e diretórios",
    }
  },
]




// WEBPACK FOOTER //
// ./src/router/routes/cargos-partidarios.js